import * as ko from 'knockout';
import { DONE } from '../../../helper';
import { IUpdateItemStateInput, SurveySingleChoiceMatrix_QueryItemSessionData_Option } from '../../../its-itembank-api.g';
import * as RICHTEXTHTML from '../../../richtext/html';
import { INIT, ItemDataModel, translate } from '../ItemDataModel';
import { ItemModel } from "../ItemModel";

function getData(item: INIT) {
    if (item.data.__typename === 'SurveySingleChoiceMatrix_QueryItemSessionData') {
        return item.data;
    }
    throw new Error();
}

type DATA = ReturnType<typeof getData>;
type ROW = DATA['sscmRows'][0];
type COLUMN = DATA['sscmColumns'][0];
type CELL = ROW['cells'][0];

export class SurveySingleChoiceMatrixData_Row {
    public readonly id: string;
    constructor(readonly model: SurveySingleChoiceMatrixData, readonly data: ROW) {
        this.id = data.id;
        this.text = translate(data.value, {});
        this.cells = data.cells.map(x => new SurveySingleChoiceMatrixData_Cell(model, this, x));
        this.selectedAnswer(data.selectedAnswer);

    }
    public readonly selectedAnswer = ko.observable<string>();
    public readonly text: string;

    public readonly cells: SurveySingleChoiceMatrixData_Cell[];

}
export class SurveySingleChoiceMatrixData_Column {
    constructor(readonly model: SurveySingleChoiceMatrixData, readonly data: COLUMN) {
        this.value = translate(data.value, {});
    }
    public readonly value: string;
}
export class SurveySingleChoiceMatrixData_Cell {
    public readonly id: string;
    public readonly isSelected = ko.pureComputed(() => this.row.selectedAnswer() === this.id);

    constructor(readonly model: SurveySingleChoiceMatrixData, readonly row: SurveySingleChoiceMatrixData_Row, readonly data: CELL) {
        this.id = data.id;
    }

}
export class SurveySingleChoiceMatrixData extends ItemDataModel {
    constructor(readonly meta: ItemModel, data: DATA) {
        super();

        this.option = data.option;
        this.headerText = translate(data.header, {});
        this.questionHTML = RICHTEXTHTML.process({
            html: translate(data.question, {}),
            attachments: this.meta.attachments,
        });
        this.rows = data.sscmRows.map(x => new SurveySingleChoiceMatrixData_Row(this, x));
        this.columns = data.sscmColumns.map(x => new SurveySingleChoiceMatrixData_Column(this, x));
        this.cells = [];
        for (const row of this.rows) {
            this.cells.push(...row.cells);
        }
        this.fromJS(data);
    }
    public fromJS(data: DATA) {
        if (data.__typename !== 'SurveySingleChoiceMatrix_QueryItemSessionData') {
            throw new Error();
        }
    }
    public readonly option: SurveySingleChoiceMatrix_QueryItemSessionData_Option;
    public readonly questionHTML: string;
    public readonly rows: SurveySingleChoiceMatrixData_Row[];
    public readonly columns: SurveySingleChoiceMatrixData_Column[];
    public readonly cells: SurveySingleChoiceMatrixData_Cell[];
    public readonly headerText: string;

    public async setAnswer({ cellId }: { cellId: string }) {
        const cell = this.cells.find(x => x.id === cellId);
        cell.row.selectedAnswer(cell.id);
    }

    public IsInteractionStarted() {
        return this.rows.some(x => !!x.selectedAnswer());
    }
    public IsInteractionComplete() {
        return this.rows.every(x => !!x.selectedAnswer());
    }
    public async reset() {
        for (const row of this.rows) {
            row.selectedAnswer(undefined);
        }
        return DONE;
    }
    public getItemState() {
        const retVal: IUpdateItemStateInput = {
            itemId: this.meta.itemId,
            SurveySingleChoiceMatrix: {
                rows: this.rows.map(x => ({
                    rowId: x.id,
                    selected: x.selectedAnswer(),
                })),
            }
        };
        return retVal;
    }

}
